const mutations = {
  onGet(state, payload) {
    payload.event.context.units = payload.response.data.data.data

    if (payload.event.context.options) {
      payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
      payload.event.context.options.page = payload.response.data.data.current_page
      payload.event.context.options.total = payload.response.data.data.total
    }
    payload.event.context.loadTable = false
  },
  onGetById (state, payload) {
    payload.event.context.editedItem = payload.response.data.data
    if (!payload.event.context.editedItem.vin_number) payload.event.context.editedItem.vin_number = ''
    if (!payload.event.context.editedItem.comment) payload.event.context.editedItem.comment = ''
    payload.event.context.loading = false
    payload.event.context.loadItem = false
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
  onPostPlate (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.loading = false
  },
  onDelete (state, payload) {
    payload.event.context.loadBtn = false
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.close()
    payload.event.context.get()
  },
  onDelPlate (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.close()
    payload.event.context.getItem()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.saveLoading = false
    payload.event.context.readingFile = false
    payload.event.context.loadBtn = false
    payload.event.context.loadTable = false
    payload.event.context.loadItem = false
  },
  onDownloadUnitsTemplate (state, payload) {
    payload.event.context.forceFileDownload(payload.response.data, 'Units_template.xlsx')
    payload.event.context.loadingTemplate = false
  },
  async onFileError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    const fr = new FileReader()
    fr.onload = (e) => {
      payload.event.context.showNotification(JSON.parse(e.target.result).message, 'error', -1)
    }
    fr.readAsText(payload.error.response.data)
    payload.event.context.loadingTemplate = false
  },
  onImportUnits (state, payload) {
    payload.event.context.units = payload.response.data.data.units
    payload.event.context.readingFile = false
  },
  onSaveUnits (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.redirect()
  },
}

export default mutations